import { Fragment } from 'react';

// styles
import {
  HeroWrapper,
  HeroEffect,
  HeroInner,
  Title,
  Copy,
  TeamPhoto,
} from './Hero.styles';

export function Hero({ content }) {
  return (
    <HeroWrapper>
      <HeroEffect intensity={0.55} phase={0} />
      <HeroInner>
        <Title>
          {content.title.map((line, index) => (
            <Fragment key={`hero-title-${line}`}>
              {index > 0 && ' '}
              <span>{line}</span>
            </Fragment>
          ))}
        </Title>
        <Copy>{content.copy}</Copy>
        <TeamPhoto
          src={content.image.src}
          alt={content.image.alt}
          width={content.image.width}
          height={content.image.height}
        />
      </HeroInner>
    </HeroWrapper>
  );
}
